exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._10ibe{height:100%}", ""]);

// exports
exports.locals = {
	"history-page": "_10ibe"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[hash:base64:5]","importLoaders":2}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/pages/HistoryPage/HistoryPage.scss
// module id = OVmf
// module chunks = 5